'use client';

import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/flp';

type OwnProps = {
  hasValidSoftPull: boolean;
};

export default function NativeMessageBridge({ hasValidSoftPull }: OwnProps) {
  useNativeMessageListener();
  useNativeMessageDispatcher(true, hasValidSoftPull);

  return null;
}
